var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 33.3818,
    cy: 32.5,
    rx: 33.3818,
    ry: 32.5,
    fill: "#F9ED33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2868 33.032V36.4654C50.2868 37.3987 49.5202 38.1654 48.5702 38.1654H45.3535C43.5535 38.1654 41.9035 36.8487 41.7535 35.0487C41.6535 33.9987 42.0535 33.0154 42.7535 32.332C43.3702 31.6987 44.2202 31.332 45.1535 31.332H48.5702C49.5202 31.332 50.2868 32.0987 50.2868 33.032Z",
    fill: "#98911F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2536 35.2667C39.1036 33.5167 39.7369 31.8 41.0036 30.55C42.0703 29.4667 43.5536 28.8333 45.1536 28.8333H46.1036C46.5703 28.8333 46.9536 28.45 46.8869 27.9833C46.4369 24.75 43.6369 22.25 40.2869 22.25H23.6203C19.9369 22.25 16.9536 25.2333 16.9536 28.9167V40.5833C16.9536 44.2667 19.9369 47.25 23.6203 47.25H40.2869C43.6536 47.25 46.4369 44.75 46.8869 41.5167C46.9536 41.05 46.5703 40.6667 46.1036 40.6667H45.3536C42.1869 40.6667 39.5203 38.3 39.2536 35.2667ZM35.2869 31.8333H25.2869C24.6036 31.8333 24.0369 31.2833 24.0369 30.5833C24.0369 29.8833 24.6036 29.3333 25.2869 29.3333H35.2869C35.9703 29.3333 36.5369 29.9 36.5369 30.5833C36.5369 31.2667 35.9703 31.8333 35.2869 31.8333Z",
    fill: "#98911F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3034 18.6333C37.7367 19.0833 37.3534 19.75 36.72 19.75H23.67C21.8534 19.75 20.1534 20.2833 18.7367 21.2C18.0867 21.6167 17.2034 21.1667 17.52 20.45C18.4534 18.2667 20.6367 16.75 23.1534 16.75H32.52C34.4534 16.75 36.17 17.4333 37.3034 18.6333Z",
    fill: "#98911F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableBalance);
export default __webpack_public_path__ + "static/media/available-balance.f9118d1cb2a0aa6e266aa42c7c4cb9cb.svg";
export { ForwardRef as ReactComponent };